// should be the same as in launchDarkly UI flag 'key' value
export enum LaunchDarklyFlags {
  FE_TEST = "lmn-pro-fe-test",
  WEB_BASED_PROPOSAL_MVP = "lp-2003-web-based-proposal-mvp",
  EnableStripePayments = "stripe-payment-integration",
  ADDITIONAL_HIDE_SHOW_OPTIONS = 'lp-3260-additional-hide-show-options-web-proposals',
  LP_3159_ESTIMATE_PHOTOS_FILES = 'lp-3159-estimate-photos-files',
  LP_4114_STALE_CHUNK_FIX = 'lp-4114-stale-chunk-fix',
  LP_4235_WORK_AREA_VISIBILITY_CONTROLS = 'lp-4235-work-area-visibility-controls',
}
